import Group3Fill from '@/assets/icons/group_3_fill.svg?component';
import Home3Fill from '@/assets/icons/home_3_fill.svg?component';
import Louse from '@/assets/icons/louse.svg?component';
import QuestionFill from '@/assets/icons/question_fill.svg?component';
import Transfer4Fill from '@/assets/icons/transfer_4_fill.svg?component';

import type { SidebarLevelConfig } from './types';

/** Region level: the top-level client view. */
export const regionLevel: SidebarLevelConfig = {
    level: 'region',
    matchPattern: '/c/:clientId',
    // No back button — region is the top-level client view
    items: [
        {
            id: 'region-overview',
            label: 'sidebarItems.region.regionOverview',
            analyticsLabel: 'Region overview',
            path: '',
            icon: Home3Fill,
            exact: true,
        },
        {
            id: 'lice-report',
            label: 'sidebarItems.shared.liceReport',
            analyticsLabel: 'Lice report',
            path: '/lice-report',
            icon: Louse,
            exact: true,
        },
        {
            id: 'change-pen',
            label: 'sidebarItems.shared.changePen',
            analyticsLabel: 'Change pen',
            path: '/change-pen',
            icon: Transfer4Fill,
            exact: true,
            isStatic: true,
            visibility: { requiresClientAdmin: true },
        },
        {
            id: 'users',
            label: 'sidebarItems.shared.users',
            analyticsLabel: 'Users',
            path: '/users',
            icon: Group3Fill,
            exact: true,
            isStatic: true,
            visibility: { requiresClientAdmin: true },
        },
        {
            id: 'help',
            label: 'sidebarItems.shared.help',
            analyticsLabel: 'Help',
            path: '/help',
            icon: QuestionFill,
            exact: true,
            isStatic: true,
        },
    ],
};
